function iterableToArrayLimit(arr, i) {

    const headerText = [];
    let onReturnIndex = true;
    let isNextLine = false;
    let error = undefined;

    try {
        for (var _i = arr[Symbol.iterator](), _s; !(onReturnIndex = (_s = _i.next()).done); onReturnIndex = true) {
            headerText.push(_s.value);
            if (i && headerText.length === i) break;
        }
    } catch (err) {
        isNextLine = true;
        error = err;
    } finally {
        try {
            if (!onReturnIndex && _i["return"] != null) _i["return"]();
        } finally {
            if (isNextLine) throw error;
        }
    }
    return headerText;
}

function arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

function nonIterableRest() {
    throw new Error("Invalid attempt to destructure non-iterable instance");
}

function slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}


export default function formatDateHeader(time, unit, labelWidth) {

    let format = {
        year: {
            long: 'YYYY',
            mediumLong: 'YYYY',
            medium: 'YYYY',
            short: 'YY'
        },
        month: {
            long: 'MMMM YYYY',
            mediumLong: 'MMMM',
            medium: 'MMM',
            short: 'MM/YY'
        },
        week: {
            long: 'w',
            mediumLong: 'w',
            medium: 'w',
            short: 'w'
        },
        day: {
            long: 'ddd D',
            mediumLong: 'ddd D',
            medium: 'ddd D',
            short: 'D'
        },
        hour: {
            long: 'dddd, DD MMMM, YYYY, HH:00',
            mediumLong: 'ddd, DD MMM, YYYY, HH:00',
            medium: 'HH:00',
            short: 'HH'
        },
        minute: {
            long: 'HH:mm',
            mediumLong: 'HH:mm',
            medium: 'HH:mm',
            short: 'mm',
        },
        second: {
            "long": 'mm:ss',
            mediumLong: 'mm:ss',
            medium: 'mm:ss',
            "short": 'ss'
        }
    };

    const timeSlice = slicedToArray(time, 2);
    const timeStart = timeSlice[0];
    const formatOptions = format;

    if (labelWidth >= 200) {
        format = formatOptions[unit]['mediumLong'];
    } else if (labelWidth >= 100) {
        format = formatOptions[unit]['medium'];
    } else if (labelWidth >= 50) {
        format = formatOptions[unit]['medium'];
    } else {
        format = formatOptions[unit]['short'];
    }

    return timeStart.format(format);
}
